varying vec2 vUv;
varying float vDepthLastEvent;
varying float vDepthDissolveValue;
uniform sampler2D dissolveTexture;
uniform float iGlobalTime;
#define lastEvent int(vDepthLastEvent)
#define dissolveValue vDepthDissolveValue
